import React from 'react';
import { DateTime } from 'luxon';

const showDateIfExists = (dateString) => {
    const dateObj = DateTime.fromISO(dateString);
    return dateObj.isValid ? dateObj.toLocaleString() : '';
};

const ReviewMedicare = ({ state }) => {
    return (
        <div className="row">
            <div className="col-md-5">
                <ul>
                    <li>
                        Your Medicare Beneficiary Number:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['medicareID']}
                        </strong>
                    </li>
                </ul>
            </div>
            <div className="col-md-5">
                <ul>
                    <li>
                        Hospital Insurance Benefits (Part A) Date: <br />
                        <strong>
                            {showDateIfExists(
                                state?.enrollment.page4.sub2[
                                    'medicareEligibilityDatePartA'
                                ]
                            )}
                        </strong>
                    </li>
                    <li>
                        Medical Insurance Benefits (Part B) Date:{' '}
                        <strong>
                            <br />
                            {showDateIfExists(
                                state?.enrollment.page4.sub2[
                                    'medicareEligibilityDatePartB'
                                ]
                            )}
                        </strong>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ReviewMedicare;
